import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  ResolveFn,
  RouterStateSnapshot,
} from '@angular/router';
import { catchError, from, of } from 'rxjs';
import { EmployeesapService } from '../home/services/employeesap.service';

export const EmployeeSAPResolverService: ResolveFn<any[]> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  return from(inject(EmployeesapService).getEmployeeSapByRut()).pipe(
    catchError(error => {
      console.error(error);
      return of([]);
    })
  );
};
